var newViewportWidth = $(window).width();
 
$('.nav__slide-menu').click(function(e){
  e.preventDefault();
  $(this).parent().find('.nav__sub').addClass('nav__slide-in');
});

$('.nav__sub-title').click(function(e){
  e.preventDefault();
  $(this).parent().removeClass('nav__slide-in');
});

$('.header__hamburger').click(function(){
  $('.nav').toggleClass('nav__slide-in');
  $('.body-overlay').toggleClass('header-active');
  $("body").toggleClass("active");
  $(this).toggleClass('active');
  
});


 // faq
 $(".faq__content").hide();
 $(".faq__title").first().addClass("active").next().show();
 $(".faq__title").click(function () {
     $(this).toggleClass("active").next().slideToggle();
     $(".faq__content").not($(this).next()).slideUp().removeClass("active");
     $(".faq__title").not(this).removeClass("active");
 });



// behind slider
 $(".behind__slider").slick({
    dots: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    infinite: false,
    // asNavFor: ".popup-slide__items",  
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ]
  });
  $(".popup-slide__items").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    // asNavFor: ".behind__items",
    focusOnSelect: true,
    arrows: false,
    fade: true,
  });
  $(".testimonials__list").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    arrows: false,
    dots: true,
  });

  function updateSlideCount(slick, currentSlide) {
    // var slideNumber = currentSlide + 1;
    // $('.behind__count span').text(slideNumber);
    // $('.popup-slide__count span').text(slideNumber);
}

$('.behind__arrow_left').on("click", function(){
    $(this).parent().parent().parent().find('.slick-slider').slick('slickPrev');
});

$('.behind__arrow_right').on("click", function(){
    $(this).parent().parent().parent().find('.slick-slider').slick('slickNext');
    var currentSlide = $('.your-element').slick('slickCurrentSlide');
});
$('.popup-slide__prev-bg').on("click", function(){
    $(this).parent().parent().find('.popup-slide__items').slick('slickPrev');
});

$('.popup-slide__next-bg').on("click", function(){
    $(this).parent().parent().find('.popup-slide__items').slick('slickNext');
});
$('.popup-slide__arrow_left').on("click", function(){
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});

$('.popup-slide__arrow_right').on("click", function(){
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});
$('.behind__items').each(function(){
  $(this).on('afterChange', function(event, slick, currentSlide){
    var slideNumber = currentSlide + 1;
      updateSlideCount(slick, currentSlide); 
      $(this).parent().find('.behind__count span').text(slideNumber);
      $(this).parent().find('.popup-slide__count span').text(slideNumber);   
      if (currentSlide === 0) {
          $(".behind__arrow_left, .popup-slide__prev-bg").addClass("hidden");
        } else {
          $(".behind__arrow_left, .popup-slide__prev-bg").removeClass("hidden");
        }
        if (currentSlide === slick.slideCount - 1) {
          $(".behind__arrow_right, .popup-slide__next-bg").addClass("hidden");
        } else {
          $(".behind__arrow_right, .popup-slide__next-bg").removeClass("hidden");
        }
      
  });
})


// var initialSlide = $('.behind__items').slick('slickCurrentSlide') + 1;
// $('.behind__count span').text(initialSlide);


// open popup
 $(".behind__item_js").click(function () {
    $(this).parent().parent().parent().parent().parent().parent().find(".popup-slide").addClass("active");
    $(".behind__items").addClass("active");
    $(".behind__top").addClass("active");
     var index = $(this).index();
     $(".popup-slide__items").slick("slickGoTo", index);
    //  $(".popup-slide").removeClass("hidden");
 });

 $(".popup-slide__cross").click(function () {
    $(".popup-slide").removeClass("active");
    $(".behind__items").removeClass("active");
    $(".behind__top").removeClass("active");
 })

$(".testimonial__slider").slick({
  dots: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 5000,
  fade: true,
});

// //  cart-drawer
// $(".header__cart").on("click", function (e) {
//   e.preventDefault();
//   $(".cart-drawer").addClass("active");
//   $(".body-overlay").addClass("cart-active");
//   $("body").addClass("active");
// });


// $(".cart-drawer__cross").on("click", function (e) {
//   e.preventDefault();
//   $(".cart-drawer").removeClass("active");
//   $(".body-overlay").removeClass("cart-active");
//   $("body").removeClass("active");
// });
$(".body-overlay").on("click", function (e) {
  e.preventDefault();
  $(".cart-drawer").removeClass("active");
  $(".body-overlay").removeClass("cart-active");
  $(".body-overlay").removeClass("header-active");
  $("body").removeClass("active");
  $(".header-drawer").removeClass("active").fadeOut();
  $(".header__ham").removeClass("active");
  $(".nav").removeClass("nav__slide-in");
  $(".header__hamburger").removeClass("active");

});

$(".cart-overlay").on("click", function (e) {
  e.preventDefault();
  $(".cart-overlay").removeClass("cart-active");
  $(".cart-drawer").removeClass("active");
  $("body").removeClass("active");

});

if (newViewportWidth < 768) {
  $(".header-drawer__link").on("click", function (e) {
    // e.preventDefault();
    $(".body-overlay").removeClass("header-active");
    $("body").removeClass("active");
    $(".header-drawer").removeClass("active").fadeOut();
    $(".header__ham").removeClass("active");
  
  });
}


//  menu-drawer
$(".header__ham").on("click", function (e) {
  e.preventDefault();
  $(".header-drawer").toggleClass("active").fadeToggle();
  $(".header__ham").toggleClass("active");
  $("body").toggleClass("active");
  $(".body-overlay").toggleClass("header-active");
});


// product description expand
$(".featured-product__des").on("click", function (e) {
  $(this).addClass("active");
})



// sticky atc


    $(window).scroll(function() {
      
      if (newViewportWidth < 768) {
      if ($(this).scrollTop() > 900) {
        $('.sticky-btn').fadeIn();
      } else {
        $('.sticky-btn').fadeOut();
      }
    }
      });





      // for animation
      var newViewportWidth = $(window).width();
      if (newViewportWidth > 1024) {
      var defaultScale = 1;
      $(window).scroll(function (event) {
        var scroll = $(window).scrollTop();
        
        $( '.scale-anim' ).each(function(){
          if( isOnScreen( $( this ) ) ) { /* Pass element id/class you want to check */
            var elemTop = $(this).offset().top;
    
            scroll = scroll - elemTop + 800;
            var scaleImage = defaultScale + (scroll * .0003);
            $(this).css('transform', 'scale3d('+scaleImage+', '+scaleImage+', 1)');
           }
        })


        $( '.scale-animat' ).each(function(){
          if( isOnScreen( $( this ) ) ) { /* Pass element id/class you want to check */
            var elemTop = $(this).offset().top;
    
            scroll = scroll - elemTop + 800;
            var scaleImage = defaultScale + (scroll * .00015);
            $(this).css('transform', 'scale3d('+scaleImage+', '+scaleImage+', 1)');
           }
        })
    });
    
    
    function isOnScreen(elem) {
      if( elem.length == 0 ) {
        return;
      }
      var $window = $(window)
      var viewport_top = $window.scrollTop()
      var viewport_height = $window.height()
      var viewport_bottom = viewport_top + viewport_height
      var $elem = $(elem)
      var top = $elem.offset().top
      var height = $elem.height()
      var bottom = top + height
    
      return (top >= viewport_top && top < viewport_bottom) ||
      (bottom > viewport_top && bottom <= viewport_bottom) ||
      (height > viewport_height && top <= viewport_top && bottom >= viewport_bottom)
    }

  }

  




  // stickey
var lastScrollTop = 0;
$(window).scroll(function (event) {
    var scroll = $(this).scrollTop();
    if (scroll > lastScrollTop) {
        $("body").removeClass("header-fixed_visible");
        if (scroll >= 100) {
            $("body").addClass("header-fixed");
        } else {
            $("body").removeClass("header-fixed");
        };
    } else {
        if (scroll >= 150) {
            $("body").addClass("header-fixed_visible");
        } else {
            $("body").removeClass("header-fixed_visible");
            $("body").removeClass("header-fixed");
        }
    }
    lastScrollTop = scroll;
});


// smooth scroll
$("[href^='#']").click(function(e) {
    var targetId = $(this).attr("href");            
    var targetElement = $(targetId);                 
    var currentPath = window.location.pathname;       
    var linkPath = this.pathname;                    

    if (currentPath === linkPath && targetElement.length) {
        e.preventDefault(); 

        var offset = (newViewportWidth < 768) ? 20 : 78;
        
        $('html, body').animate({
            scrollTop: targetElement.offset().top - offset
        }, 1500);
    }
    // If on a different page, let the default link behavior proceed (normal navigation)
});




